export enum MODAL_SELECTORS {
  SELECT_TOKEN = "SELECT_TOKEN",
  WALLET_CONNECT = "WALLET_CONNECT",
  CONFIRM_TRADE = "CONFIRM_TRADE",
  WALLET_VIEW = "WALLET_VIEW",
  APPROVE_ALLOWANCE = "APPROVE_ALLOWANCE",
  SWITCH_NETWORK = "SWITCH_NETWORK",
  TRANSACTION_DETAIL = "TRANSACTION_DETAIL",
  REGION_RESTRICTED = "REGION_RESTRICTED",
}
